<template>
    <section
        class="vacancy-section"
        :class="`vacancy-section--${theme}`"
    >
        <div
            class="vacancy-section__container"
            :class="{'container': useContainer}"
        >
            <div class="vacancy-section__info">
                <h2 class="vacancy-section__title" v-html="text.title" />
                <template v-if="lang === 'ru'">
                    <z-button
                        class="vacancy-section__button"
                        tag="a"
                        :size="device === 'mobile' ? 's' : 'm'"
                        href="/career/vacancies/"
                        kind="bordered"
                    >
                        {{ text.buttonTitle}}
                        <template #right>
                            <z-icon
                                name="arrows/round-arrow-big"
                                width="36"
                                height="36"
                                dir="right"
                            />
                        </template>
                    </z-button>
                </template>
            </div>
            <template v-if="lang === 'ru'">
                <vacancy-card-slider
                    class="vacancy-section__slider"
                    :card-list="vacancies"
                />
            </template>
        </div>
    </section>
</template>
<script setup>
import VacancyCardSlider from '@/components/VacancyCardSlider'
import {useGetter} from '@/composable/useGetter'
import {localize} from '@/utils/i18n'

const { lang } = useGetter(['lang'])

defineProps({
    theme: {
        type: String,
        validator: prop => ['light', 'dark'].includes(prop),
        default: 'dark'
    },
    useContainer: {
        type: Boolean,
        default: false
    },
    hasBackground: {
        type: Boolean,
        default: false,
    }
})

const text = {
    buttonTitle: localize({
        ru: 'Вакансии',
        en: 'Vacancies',
        cn: 'Vacancies'
    }),
    title: localize({
        ru: 'Есть где развернуться и&nbsp;тайге, <br>и&nbsp;твоей карьере!',
        en: 'Plenty of&nbsp;opportunities fro both the&nbsp;environment<br>and your career!',
        cn: '这里有足够的空间让针叶林和您的事业蓬勃发展！'
    }),
}

const {device} = useGetter(['device'])
const {app} = useGetter(['app'])
const vacancies = app.value.components.vacancies.items

</script>

<style lang="scss">
.vacancy-section{
    position: relative;
    padding: 17.8798% 0 11.322%;

    @include breakpoint(mobile){
        padding: 40px 0;
        background-size: unset;
        background-position: 85% 52%;
    }


    &--dark{
        --font-color: var(--color-black-90);

        & .swiper-slide {
            &:not(.swiper-slide-active) {
                & .z-card {
                    background: rgba(236, 244, 241, 0.80);
                    backdrop-filter: blur(20px);
                    opacity: 0.9;
                }
            }

            & .z-card {
                filter: blur(0);
                opacity: 1;
                transition: all .4s ease-in-out;
            }
        }
    }

    &--light{
        --font-color: var(--color-white);
    }

    &__work-with-us{

        &:before{
            content: '';
            position: absolute;
            top: 0;
            left: 50%;
            width: 100vw;
            height: 100%;
            background: url(/local/templates/z-template/images/vacancy-section-bg-20260414.jpg) no-repeat;
            background-size: cover;
            transform: translate(-50%, 0);
            pointer-events: none;
            z-index: -1;
        }
    }

    &__container{
        position: relative;
        display: flex;
        @include gap-level(3XL);
        z-index: 1;

        @include breakpoint(v-tablet){
            flex-direction: column;
        }

        @include breakpoint(mobile){
            @include gap-level(XL);
        }
    }

    &__info{
        max-width: 31.5%;
        width: 100%;
        @include breakpoint(v-tablet){
            max-width: 100%;
        }
    }

    &__title{
        @include margin-level(bottom, M);
        font-size: 48px;
        font-weight: 500;
        line-height: 120%;
        color: var(--font-color);

        @include breakpoint(v-tablet){
            font-size: 32px;
        }
        @include breakpoint(mobile){
            margin: 0;
            font-size: 26px;
        }
    }

    &__button{
        @include breakpoint(mobile){
            margin: 40px 0;
            width: fit-content;
        }
    }

    &__slider{
        margin-top: 36px;
        width: 100%;
    }
}
</style>
